import clsx from 'clsx'
import { useTestOpsCommandConfig } from '../context'

export function AssistantAvatar({
  size = 'md',
  surface = 'light',
}: {
  size?: 'sm' | 'md' | 'lg'
  surface?: 'light' | 'brand'
}) {
  // The host product (Athena, Toucan, ...) injects its own logo as the
  // assistant's face. The package itself is brand-agnostic.
  const { AvatarComponent } = useTestOpsCommandConfig()

  const containerClass =
    size === 'lg'
      ? 'h-20 w-20 rounded-2xl'
      : size === 'sm'
        ? 'h-8 w-8 rounded-full'
        : 'h-12 w-12 rounded-xl'

  const logoSize = size === 'lg' ? 48 : size === 'sm' ? 18 : 28
  const surfaceClass =
    surface === 'brand'
      ? 'ring-1 ring-accent/20'
      : 'bg-accent-soft ring-1 ring-accent/30'

  return (
    <div className={clsx('flex items-center justify-center flex-shrink-0', containerClass, surfaceClass)}>
      <AvatarComponent size={logoSize} />
    </div>
  )
}
